// ============================================================================
// PAYMENT ENDPOINTS
// ============================================================================

import { buildEndpoint, buildEndpointWithParams } from './base.endpoints';
import type { ID } from '../types';

const BASE_PATH = '/Payment';

export const paymentEndpoints = {
  list: () => buildEndpoint(BASE_PATH),
  getById: (id: ID) => buildEndpointWithParams(`${BASE_PATH}/:id`, { id }),
  /** GET /Payment/booking/:bookingId — list of payments for a single booking. */
  getByBookingId: (bookingId: ID) =>
    buildEndpointWithParams(`${BASE_PATH}/booking/:bookingId`, { bookingId }),
  create: () => buildEndpoint(BASE_PATH),
  update: (id: ID) => buildEndpointWithParams(`${BASE_PATH}/:id`, { id }),
  void: (id: ID) => buildEndpointWithParams(`${BASE_PATH}/:id`, { id }),
} as const;

export default paymentEndpoints;
